/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Cerca',
  search_no_results_1: 'Ci spiace.',
  search_no_results_2: "Non è possibile trovare l'emoji",
  pick: 'Scegli un emoji…',
  add_custom: 'Aggiungi emoji personalizzato',
  categories_activity: 'Attività',
  categories_custom: 'Personalizzato',
  categories_flags: 'Bandiere',
  categories_foods: 'Cibo e bevande',
  categories_frequent: 'Utilizzati di frequente',
  categories_nature: 'Animali e natura',
  categories_objects: 'Oggetti',
  categories_people: 'Smiley e persone',
  categories_places: 'Viaggi e luoghi',
  categories_search: 'Risultati ricerca',
  categories_symbols: 'Simboli',
  skins_choose: 'Scegli la carnagione predefinita',
  skins_1: 'Predefinito',
  skins_2: 'Chiaro',
  skins_3: 'Medio chiara',
  skins_4: 'Media',
  skins_5: 'Medio scura',
  skins_6: 'Scura',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
